// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productsLoader":"yTTLx","productLoaderContainer":"C8jKV","loading":"t0Okb"};